// extracted by mini-css-extract-plugin
export var chevron = "_pa-1";
export var clickable = "_pa-0";
export var ruleRow = "_pa-2";